<div class="flex h-screen w-full">
  <!-- overlay -->
  @if (layout.isMobileOpen()) {
    <div
      (click)="layout.toggleMobileSidebar()"
      class="fixed inset-0 bg-black/40 z-30 lg:hidden"
    ></div>
  }

  <app-sidebar></app-sidebar>

  <!-- OJO: overflow-hidden SOLO aquí, y min-h-0 min-w-0 para flex -->
  <div class="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">

    <!-- header en su propia “barra” -->
    <div class="shrink-0">
      <app-header></app-header>
    </div>

    <!-- contenido scrolleable -->
    <div class="flex-1 min-h-0 overflow-y-auto">
      <div class="p-6 space-y-6">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
</div>